const VELOSTRUCT_META_LINE_RE = /^\s*%%\s*@velostruct:.*$/gm;

function escapeHtml(raw: string): string {
  return raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function highlightMermaidLine(line: string): string {
  const trimmed = line.trimStart();
  if (trimmed.startsWith('%%')) {
    return `<span style="color:#22c55e">${escapeHtml(line)}</span>`;
  }

  const escaped = escapeHtml(line);
  const tokenRegex = /\b(sequenceDiagram|flowchart|graph|participant|actor|box|loop|alt|opt|par|end|subgraph|title|note|autonumber|classDef|style|linkStyle)\b|(-->>|->>|-->|<--|==>|--\)|--x|-x|\+\+|--)|("[^"]*"|'[^']*')/g;

  return escaped.replace(tokenRegex, (token, keyword, arrow, quoted) => {
    if (keyword) return `<span style="color:#818cf8;font-weight:600">${keyword}</span>`;
    if (arrow) return `<span style="color:#f59e0b;font-weight:600">${arrow}</span>`;
    if (quoted) return `<span style="color:#38bdf8">${quoted}</span>`;
    return token;
  });
}

export function highlightMermaidHtml(code: string): string {
  if (!code) return '';
  return code
    .split('\n')
    .map(highlightMermaidLine)
    .join('\n');
}

export function stripVelostructMetadata(code: string): string {
  const stripped = code.replace(VELOSTRUCT_META_LINE_RE, '').replace(/\n{3,}/g, '\n\n');
  return stripped.trimEnd();
}

export function countCodeStats(code: string): { lines: number; chars: number } {
  if (!code) return { lines: 0, chars: 0 };
  return {
    lines: code.split('\n').length,
    chars: code.length,
  };
}
